(() => {
  const POSTA1_URL = '/products/lettera-prioritaria-online-posta1';

  const fixPosta1Links = () => {
    if (!/^\/pages\/eccomi-posta\/?$/.test(window.location.pathname)) return;

    document.querySelectorAll('a[href]').forEach((link) => {
      const text = (link.textContent || '').trim();
      const href = link.getAttribute('href') || '';

      if (/posta\s*1/i.test(text) || /posta1/i.test(href)) {
        link.setAttribute('href', POSTA1_URL);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixPosta1Links);
  } else {
    fixPosta1Links();
  }

  document.addEventListener('shopify:section:load', fixPosta1Links);
})();
